import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetariProiecteComponent } from './setari-proiecte.component';
import { MaterialModule } from 'src/app/material.module';
import { CategoriiProiecteModule } from './categorii-proiecte/categorii-proiecte.module';
import { SectiuniProiecteModule } from './sectiuni-proiecte/sectiuni-proiecte.module';
import { StatusuriProiecteModule } from './statusuri-proiecte/statusuri-proiecte.module';
import { TaguriProiecteModule } from './taguri-proiecte/taguri-proiecte.module';
import { FurnizoriProiecteModule } from './furnizori-proiecte/furnizori-proiecte.module';
import { AgentiProiecteModule } from './agenti-proiecte/agenti-proiecte.module';
import { MotiveProiecteModule } from './motive-proiecte/motive-proiecte.module';
import { OperatoriProiecteModule } from './operatori-proiecte/operatori-proiecte.module';

@NgModule({
    declarations: [SetariProiecteComponent],
    imports: [
        CommonModule,
        MaterialModule,
        CategoriiProiecteModule,
        SectiuniProiecteModule,
        StatusuriProiecteModule,
        TaguriProiecteModule,
        FurnizoriProiecteModule,
        AgentiProiecteModule,
        MotiveProiecteModule,
        OperatoriProiecteModule,
    ],
    exports: [SetariProiecteComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SetariProiecteModule { }
